import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export interface IEditBriefNotesPayload {
  briefInfluencerId: string;
  agencySharedBrandNotes?: string;
  brandNotes?: string;
}

export function useEditBriefInfluencerNotes(
  briefId?: string,
  handleCallback?: () => void
) {
  const {
    mutate: editNotes,
    isLoading: isEditingNotes,
    isSuccess: isEditedNotes,
    error: editNotesError,
    variables,
  } = useMutation({
    mutationFn: (data: IEditBriefNotesPayload) =>
      BriefService.editBriefNotes(data).catch(async (err) => {
        const responseBody = await err?.response?.json().catch(() => ({}));
        if (responseBody?.msg) {
          ToastService.error(responseBody.msg);
        }
        throw err;
      }),
    options: {
      skipInvalidation: true
    },
    onSuccess: (c) => {
      handleCallback?.();
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
    },
  });

  return {
    editNotes,
    isEditingNotes,
    isEditedNotes,
    editNotesError,
    variables,
  };
}
